
import { AboutItemWrapper } from './style';

// Components
import Text from 'components/common/Text';
import Image from 'next/image';

const AboutItem = ({ item: {img, desc, id} }) => {

    return (
        <AboutItemWrapper 
            key={id}
        >
            <div className='img'>
                <Image
                    src={img}
                    width={60}
                    height={60}
                    alt={desc}
                />
            </div>
           
            <Text
                tag="h3"
                className="desc"
            >
                {desc}
            </Text>
        </AboutItemWrapper>
    )
}

export default AboutItem;